// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2juVF","ranges":"BmiRanges_ranges__tTIV1"};